<div class="row">
  <div class="col-md-12">
    <app-cliente-list></app-cliente-list>
    <!--        <div class="card">
              <div class="card-header text-center">
                <p class="h4">Crear Cliente</p>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <form
                      action=""
                      [formGroup]="clientForm"
                      (ngSubmit)="registerClient()"
                      class="form-horizontal form-material"
                      id="categoryform"
                      novalidate
                    >
                      <div class="form-group row m-t-20">
                        <div class="col-xs-12 col-md-6">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['nombres']"
                            [controlName]="'Nombre '"
                          >
                            <label for="name"></label>
                            <input
                              class="form-control"
                              type="text"
                              id="name"
                              formControlName="nombres"
                              placeholder="Nombre de Cliente"
                            />
                          </app-form-error-wrapper>
                        </div>
                        <div class="col-xs-12 col-md-6">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['apellidos']"
                            [controlName]="'Apellido '"
                          >
                            <label for="lastName"></label>
                            <input
                              class="form-control"
                              type="text"
                              id="lastName"
                              formControlName="apellidos"
                              placeholder="Apellido de Cliente"
                            />
                          </app-form-error-wrapper>
                        </div>
                      </div>
                      <div class="form-group m-t-20">
                        <div class="col-xs-12">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['ci_nit']"
                            [controlName]="'CI '"
                          >
                            <input
                              class="form-control"
                              type="text"
                              formControlName="ci_nit"
                              placeholder="CI de Cliente"
                            />
                          </app-form-error-wrapper>
                        </div>
                      </div>
                      <div class="form-group m-t-20">
                        <div class="col-xs-12">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['direccion']"
                            [controlName]="'Direccion '"
                          >
                            <input
                              class="form-control"
                              type="text"
                              formControlName="direccion"
                              placeholder="Direccion de Cliente"
                            />
                          </app-form-error-wrapper>
                        </div>
                      </div>
                      <div class="form-group m-t-20">
                        <div class="col-xs-12">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['email']"
                            [controlName]="'Correo Electronico '"
                          >
                            <input
                              class="form-control"
                              type="email"
                              formControlName="email"
                              placeholder="Ejemplo@gmail.com"
                            />
                          </app-form-error-wrapper>
                        </div>
                      </div>
                      <div class="form-group m-t-20">
                        <div class="col-xs-12">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['foto']"
                            [controlName]="'Imagen '"
                          >
                            <input
                              class="form-control"
                              type="text"
                              formControlName="foto"
                              placeholder="Foto de Cliente"
                            />
                          </app-form-error-wrapper>
                        </div>
                      </div>
                      <div class="form-group m-t-20">
                        <div class="col-xs-12">
                          <app-form-error-wrapper
                            [control]="clientForm.controls['celular']"
                            [controlName]="'N° de celular '"
                          >
                            <input
                              class="form-control"
                              type="number"
                              formControlName="celular"
                              placeholder="N° celular "
                            />
                          </app-form-error-wrapper>
                        </div>
                      </div>
                      <div class="form-group text-center m-t-20">
                        <div class="col-xs-12">
                          <button
                            class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                            [disabled]="clientForm.invalid || isLoading"
                          >
                            <app-button-loader
                              [isLoading]="isLoading"
                              [label]="'Agregar'"
                            ></app-button-loader>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-12 ">
            <div class="card">
              <div class="card-header text-center">
                <p class="h4">Listar Clientes</p>
              </div>
              <div class="card-body">
                <table class="table table-hover table-sm table-md">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre Completo</th>
                      <th>Nit</th>
                      <th>Direccion</th>
                      &lt;!&ndash;                  <th>Habilitado</th>&ndash;&gt;
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let client of clients; let i = index">
                    <tr>
                      <th scope="row">{{ i + 1 }}</th>
                      <td>{{ client.nombres + ' ' + client.apellidos }}</td>
                      <td>{{ client.ci_nit }}</td>
                      <td>{{ client.direccion }}</td>
                      &lt;!&ndash; <td class="mt-2">
                        <label
                          class="switch switch_type1"
                          role="switch"
                          *ngIf="client.habilitado == true"
                        >
                          <input
                            type="checkbox"
                            class="switch__toggle"
                            (click)="enableClient(client.cliente_id)"
                            checked="false"
                          />
                          <span class="switch__label"></span>
                        </label>
                        <label
                          class="switch switch_type1"
                          role="switch"
                          *ngIf="client.habilitado == false"
                        >
                          <input
                            type="checkbox"
                            class="switch__toggle"
                            (click)="enableClient(client.cliente_id)"
                          />
                          <span class="switch__label"></span>
                        </label>
                      </td>&ndash;&gt;
                      <td>
                        <button type="button" class="btn btn-default btn-lg">
                          <i class="fa fa-pencil-square-o"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>-->
  </div>
</div>
